// WHY (#2175): typed wrapper for `PATCH /requests/:id/container-totals`.
//   Mirrors the crud.ts pattern: response validated against RequestSchema.

import type { ZodType } from 'zod';
import { RequestSchema, type Request } from '@magimp/shared';
import { request } from '../client.js';

export function setContainerTotals(
  id: string,
  body: { weight: number; volume: number },
): Promise<Request> {
  return request<Request>(
    `/requests/${encodeURIComponent(id)}/container-totals`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: { 'content-type': 'application/json' },
    },
    {},
    RequestSchema as unknown as ZodType<Request>,
  );
}
